export default "__VITE_PUBLIC_ASSET__eb2d7395__"